module.exports = __webpack_public_path__ + "img/1403.0c3193a1.jpg";